module.exports = __webpack_public_path__ + "static/media/usb-drive.624a4815.svg";